@if (userSessionService.activeUser()) {
	<!-- User Profile Dropdown -->
	<div class="nav-item dropdown">
		<a class="nav-link dropdown-toggle d-flex align-items-center" tabindex="0" role="button"
			data-bs-toggle="dropdown">
			<ms-avatar class="me-2" [identity]="userSessionService.activeUser()" [avatarSize]="avatarSize" [avatarShape]="avatarShape" [avatarAdditionalAttributes]="avatarAdditionalAttributes"></ms-avatar>
			<div class="d-none d-sm-flex flex-column align-items-start">
				<span class="fw-bold fs-7">{{userSessionService.activeUser()?.firstName}} {{userSessionService.activeUser()?.lastName}}</span>
			</div>
		</a>
		<ul class="dropdown-menu dropdown-menu-end user-dropdown">
			<li class="dropdown-header">
				<div class="d-flex align-items-center">
					<ms-avatar class="me-2" [identity]="userSessionService.activeUser()" [avatarSize]="avatarDropdownMenuHeaderSize" [avatarShape]="avatarShape" [avatarAdditionalAttributes]="avatarAdditionalAttributes"></ms-avatar>
					<div class="min-w-0">
						<div class="fw-bold text-truncate min-w-0"
							[msTooltip]="(userSessionService.activeUser()?.firstName ?? '') + ' ' + (userSessionService.activeUser()?.lastName ?? '')"
							msTooltipOnlyIfTruncated>
							{{userSessionService.activeUser()?.firstName}} {{userSessionService.activeUser()?.lastName}}
						</div>
						<div class="fs-7 text-truncate min-w-0"
							[msTooltip]="userSessionService.activeUser()?.emailAddress ?? ''"
							msTooltipOnlyIfTruncated>
							{{userSessionService.activeUser()?.emailAddress}}
						</div>
					</div>
				</div>
			</li>
			<li><a class="dropdown-item" [routerLink]="['/users/profile', userSessionService.activeUser()?.userId]"><fa-duotone-icon icon="user" class="me-2"/>My Profile</a></li>
			<li><hr class="dropdown-divider"></li>
			<li><a class="dropdown-item text-danger" (click)="logOutRequested.emit()"><fa-duotone-icon icon="sign-out-alt" class="me-2"/>Sign Out</a></li>
		</ul>
	</div>
} @else {
	<div class="nav-item placeholder-glow">
		<div class="d-flex align-items-center">
			<ms-avatar class="me-2"
				[identity]="null"
				[avatarSize]="avatarSize"
				[avatarShape]="avatarShape"
				[avatarAdditionalAttributes]="avatarAdditionalAttributes"
				[isLoading]="true">
			</ms-avatar>
			<div class="d-none d-sm-flex flex-column align-items-start">
				<span class="fw-bold fs-7 placeholder col-8" style="width: 100px;">&nbsp;</span>
			</div>
		</div>
	</div>
}
